import React, { useState, useEffect } from "react";
import { Box, TextField, useTheme } from '@mui/material';
import { tokens } from "../../../assets/theme";
import 'dayjs/locale/sv';
import 'dayjs/locale/en';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from "dayjs";

const GridDateTimePicker = (props) => {
    const [draft, setDraft] = useState(props.date ? dayjs(props.date) : null);

    useEffect(() => {
        setDraft(props.date ? dayjs(props.date) : null);
    }, [props.date]);

    const textFieldSx = props.width ? { width: props.width } : undefined;

    return (
        <Box sx={{
            "& .MuiInputBase-input": {
                color: "secondary",
                height: "0.4375em",
            },
            "& .MuiTextField-root": {
                marginTop: "10px",
                marginBottom: "10px",
            },
            "& .MuiPaper-root": {
                backgroundColor: "#fff"
            },
        }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={props.locale || 'sv'}>
                <DateTimePicker
                    label={props.label}
                    value={draft}
                    renderInput={(params) => <TextField {...params} sx={textFieldSx} />}
                    maxDate={props.maxDate}
                    minDate={props.minDate}
                    minutesStep={1}
                    onChange={(newValue) => {
                        setDraft(newValue);
                        props.onDirectChange?.(newValue);
                    }}
                    onAccept={(finalValue) => {
                        props.onChange?.(finalValue);
                    }}
                    componentsProps={{
                        actionBar: {
                            actions: ["cancel", "accept"],
                            sx: {
                                px: 2,
                                pb: 1,
                                "& .MuiButton-root": {
                                    fontWeight: 700,
                                    borderRadius: 2,
                                    minWidth: 96,
                                },
                                // Cancel (första knappen)
                                "& .MuiButton-root:nth-of-type(1)": {
                                    color: "text.secondary",
                                    "&:hover": { backgroundColor: "action.hover" },
                                },
                                // OK (andra knappen)
                                "& .MuiButton-root:nth-of-type(2)": {
                                    backgroundColor: "primary.main",
                                    color: "primary.contrastText",
                                    "&:hover": { backgroundColor: "primary.dark" },
                                },
                            },
                        },
                    }}
                />
            </LocalizationProvider>
        </Box>

    )

}
export default GridDateTimePicker;